export default __webpack_public_path__ + "static/media/Journal_Review@2x.33d7e130.png";